<template>
  <div>
    <van-nav-bar style="box-shadow: 0px 1px 4px #CFCFCF;" title="业务进度" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
    <!-- <van-row justify="center" type="flex" style="text-align: center; background-color: #FFFFFF;margin: 10px; ">
      <van-col span="15" style="color: black;     ">
        <van-search v-model="Searvalue" show-action placeholder="请输入搜索关键词" style="height: 48px;box-shadow: 0 2px 12px rgba(100,101,102,.12);"
                    @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </van-col>
      <van-col span="9" style="color: black;">
        <van-dropdown-menu>

          <van-dropdown-item v-model="value2" :options="option2" @closed="sts()"/>
        </van-dropdown-menu>
      </van-col>
    </van-row> -->

    <van-tabs type="line" animated style="" @click="onClick">
      <van-tab title="审核类工单">
        <div
          v-for="item in wxbill"
          v-if="item.type != '社保-员工修改' && item.type != '社保-定点医院变更' && item.type != '社保-个人信息变更'"
          :key="item.id"
          :class="{ box11: isbox, shadow: shadow, xa: xa }"
          @change="(xa = true), (shadow = false)"
          @click="cliX(item)"
        >
          <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;font-size: 14px;">
            <van-col span="8" style="color:#ee0a24;">姓名</van-col>
            <van-col span="8" style="color: #ee0a24;">业务类型</van-col>
            <van-col span="8" style="color:#ee0a24;">服务单状态</van-col>
          </van-row>
          <van-row justify="center" type="flex" style="text-align: center;padding:2px;border-radius:10px;">
            <van-col span="8">{{ item.emp_name }}</van-col>
            <van-col span="8">{{ item.type }}</van-col>
            <van-col span="8">
              {{ item.sa }}
              <br >
            </van-col>
          </van-row>
          <van-icon name="ellipsis" style="position: absolute; left: 95%;top:8px;" />
        </div>
        <van-empty v-if="ifempty" description="暂无数据" />

      </van-tab>
      <van-tab title="非审核类工单">
        <div
          v-for="item in wxbill"
          v-if="item.type == '社保-员工修改' || item.type == '社保-定点医院变更' || item.type == '社保-个人信息变更'"
          :key="item.id"
          :class="{ box11: isbox, shadow: shadow, xa: xa }"
          @change="(xa = true), (shadow = false)"
          @click="cliX(item)"
        >
          <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
            <van-col span="8" style="color:#1196FF">姓名</van-col>
            <van-col span="8" style="color: #1196FF">业务类型</van-col>
            <van-col span="8" style="color:#1196FF">服务单状态</van-col>
          </van-row>
          <van-row justify="center" type="flex" style="text-align: center;padding:2px;border-radius:10px; font-size: 14px;">
            <van-col span="8">{{ item.emp_name }}</van-col>
            <van-col span="8">{{ item.type }}</van-col>

            <van-col span="8">
              {{ item.sa }}
              <br >
            </van-col>
            <!-- <van-col v-else span="8" style="color: #259C5C;">
              已提交 {{ item.sa }}
              <br >
            </van-col> -->
          </van-row>
          <van-icon name="ellipsis" style="position: absolute; left: 95%;top:8px;" />
        </div>
        <van-empty v-if="ifempty" description="暂无数据" />
      </van-tab>
    </van-tabs>
    <!-- 非审核类弹出层 -->
    <div>
      <van-popup v-model="show5" closeable round style="width: 350px;">
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;margin-top: 20px;">
          <van-col span="8" style="color: #9DC6FF; line-height: 44px;">身份证尾号</van-col>
          <van-col span="8" style="color: black; line-height: 44px;" />
          <van-col span="8" style="color: black; line-height: 44px;">{{ cli.id_card }}</van-col>
        </van-row>

        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field :placeholder="cli.create_time != undefined ? cli.create_time : ''" readonly style="text-align: center;padding: 5px; " label="服务申请时间" input-align="right" />
          </van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field
              v-model="message"
              :placeholder="cli.message != undefined ? cli.message : '反馈信息'"
              readonly
              style="text-align: center;padding: 5px; "
              label="反馈信息"
              input-align="right"
            />
          </van-col>
        </van-row>
        <div v-if="bankOrno">
          <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
            <van-col span="22" style="color: black; line-height: 44px;">
              <van-field
                :placeholder="card_no != undefined ?card_no : '银行卡号'"
                readonly
                style="text-align: center;padding: 5px; "
                label="银行卡号"
                input-align="right"
              />
            </van-col>
          </van-row>
          <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
            <van-col span="22" style="color: black; line-height: 44px;">
              <van-field
                :placeholder="bank_name != undefined ?bank_name : '银行名称'"
                readonly
                style="text-align: center;padding: 5px; "
                label="银行名称"
                input-align="right"
              />
            </van-col>
          </van-row>
        </div>

      </van-popup>
    </div>

    <!-- 减员弹出层 -->
    <div>
      <van-popup v-model="show" :class="{ xaaa: !cli.disable, xxxa: cli.disable }" closeable round style="width: 350px; height: 240px;">
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;margin-top: 20px;">
          <van-col span="8" style="color: #9DC6FF; line-height: 44px;">身份证尾号</van-col>
          <van-col span="8" style="color: #11C677; line-height:44px;" />
          <van-col span="8" style="color: black; line-height:44px;">{{ cli.id_card }}</van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="8" style="color: #9DC6FF; line-height: 44px;">减员月份&nbsp;&nbsp;&nbsp;&nbsp;</van-col>
          <van-col span="8" style="color: #11C677; line-height:44px;" />
          <van-col span="8" style="color:black; line-height:44px;">{{ cli.reduce_month ? cli.reduce_month : '' }}</van-col>
        </van-row>

        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field :placeholder="cli.create_time != undefined ? cli.create_time : ''" readonly style="text-align: center;padding: 5px; " label="服务申请时间" input-align="right" />
          </van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field
              v-model="message"
              :placeholder="cli.message != undefined ? cli.message : '暂无反馈'"
              style="text-align: center;padding: 5px; "
              label="反馈信息"
              input-align="right"
            />
          </van-col>
        </van-row>
      </van-popup>
    </div>

    <!-- 新参保弹框 -->
    <div>
      <van-popup v-model="show4" :class="{ xaaa: !cli.disable, xxxa: cli.disable }" closeable round closeable round style="width: 350px; height: 240px;">
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;margin-top: 20px;">
          <van-col span="8" style="color: #9DC6FF; line-height: 44px;">身份证尾号</van-col>
          <van-col span="8" style="color: #11C677; line-height:44px;">缴费年月</van-col>
          <van-col span="8" style="color: #9DC6FF; line-height:44px;">缴费基数</van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="8" style="color: black; line-height: 44px;">{{ cli.id_card }}</van-col>
          <van-col span="8" style="">
            <span style="color: #9DC6FF; line-height: 44px;">{{ cli.add_month ? cli.add_month : '' }}</span>
          </van-col>
          <van-col span="8" style="color: #9DC6FF; line-height: 44px;">
            <van-field v-model="cli.apply_salary" readonly type="number" style=" text-align: center; padding-left: 34%;" />
          </van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field :placeholder="cli.create_time != undefined ? cli.create_time : ''" readonly style="text-align: center;padding: 5px; " label="服务申请时间" input-align="right" />
          </van-col>
        </van-row>
        <van-row justify="center" type="flex" style="text-align: center;padding: 5px;border-radius:10px;">
          <van-col span="22" style="color: black; line-height: 44px;">
            <van-field
              v-model="message"
              :placeholder="cli.message != undefined ? cli.message : '暂无反馈信息'"
              readonly
              style="text-align: center;padding: 5px; "
              label="反馈信息"
              input-align="right"
            />
          </van-col>
        </van-row>
      </van-popup>
    </div>

    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        type="year-month"
        title="选择年月"
        @cancel="show2 = false"
        @confirm="_datex(currentDate)"
      />
    </van-popup>
    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="reduce_reason" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" /></van-popup>

    <van-popup v-model="show3" round position="bottom"><van-picker :columns="status" show-toolbar @cancel="show3 = false" @confirm="onConfirmS" /></van-popup>
  </div>
</template>

<script>
import { modify } from '../../../api/Hrbill.js';
// import { Toast } from 'vant';
import { WxSocList, WxSocmodify } from '@/api/Hrfund';
import Vue from 'vue';
import { Dialog } from 'vant';

// 全局注册
Vue.use(Dialog);
export default {
  name: 'WxListEmp',
  qc: {
    type: Object,
    default: function() {
      return {};
    }
  },
  data() {
    return {
      timeValue: sessionStorage.getItem('timeValue'),
      isbox: true,
      value1: 0,
      value2: 0,
      Searvalue: '',
      option1: [{ text: '全部商品', value: 0 }, { text: '新款商品', value: 1 }, { text: '活动商品', value: 2 }],
      option2: [
        { text: '默认排序', value: 0 },
        { text: '待审核', value: 1 },
        { text: '审核通过', value: 2 },
        { text: '审核不通过', value: 3 },
        { text: '办理中', value: 4 },
        { text: '服务完成', value: 5 },
        { text: '已提交', value: 6 },
        { text: '问题工单', value: 7 },
        { text: '服务终止', value: 8 }
      ],
      show5: false,
      shadow: true,
      xa: false,
      xac: false,
      show2: false,
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      active: '1',
      wxbill: [],
      examine: '',
      show: false,
      cli: {},
      message: '',
      show3: false,
      reduce_reason: ['合同到期', '主动离职', '辞退'],
      status: ['待审核', '审核通过', '审核不通过', '办理中', '服务完成', '已提交', '问题工单', '服务终止'],
      value: '',
      showPicker: false,
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      show4: false,
      bankOrno: false,
      card_no: '',
      bank_name: '',
      ifempty: false
    };
  },
  beforeMount() {},
  created() {},
  mounted() {
    if (sessionStorage.getItem('emp_id') != 'null') {
      this.query();
    }
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    _datex(value) {
      const val = value;
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      this.show2 = false;
      this.cli.add_month = `${year}-${month} `;
      this.cli.reduce_month = `${year}-${month} `;
    },
    onConfirm(value, index) {
      this.value = value;
      this.showPicker = false;
      this.cli.reduce_reason = value;
      for (let i = 0; i < this.reduce_reason.length; i++) {
        if (this.reduce_reason[i] === value) {
          console.log(i);
          this.cli.redu_id = i;
        }
      }
    },
    onConfirmS(value, index) {
      // this.value = value;
      this.show3 = false;
      Dialog.confirm({
        title: '请确认您的操作',
        message: value
      })
        .then(() => {
          // on confirm

          this.examine = value;
          this.axios
            .post('/wxbill/modify', {
              id: this.cli.id,
              status: parseInt(`${index}`) + 1,
              token: sessionStorage.getItem('token'),
              reduce_month: this.cli.reduce_month.trim(),
              type: this.cli.type,
              reduce_reason: this.cli.redu_id,
              apply_salary: this.cli.apply_salary,
              add_month: this.cli.add_month,
              feedback: this.message
            })
            .then(res => {
              if (res.data.success) {
                this.show = false;
                this.show4 = false;

                this.axios
                  .post('/wxbill/history-add', {
                    token: sessionStorage.getItem('token'),
                    emp_id: this.cli.emp_id,
                    client_id: this.cli.client_id,
                    bill_id: this.cli.bill_id,
                    status: parseInt(`${index}`) + 1,
                    feedback: this.message,
                    create_id: 9999999
                  })
                  .then(res => {
                    console.log(res);
                  });
                this.query();
              }
            });

          this.show = false;
        })
        .catch(() => {
          // on cancel
        });
      // this.cli.reduce_reason = value;
    },
    onClick(name, title) {
      if (name === 0) {
        this.xa = false;
      } else {
        this.xa = true;
      }
    },
    cliX(val, index) {
      this.message = '';
      this.cli.id = val.id;
      this.cli.emp_id = val.emp_id;
      this.cli.client_id = val.client_id;
      this.cli.bill_id = val.id;
      this.cli.status = val.status;
      this.cli.message = val.feedback;

      this.cli.create_time = val.create_time.substring(0, 10);
      console.log(this.cli.create_time + '----' + val.create_time.substring(0, 10));
      switch (val.type) {
        case '社保-减员':
          this.show = true;
          // reduce_reason:你再前台处理下，0代表合同到期，1代表主动离职，2代表辞退
          if (val.reduce_reason !== undefined) {
            this.cli.reduce_reason = this.reduce_reason[parseInt(val.reduce_reason)];
          }
          this.cli.type = val.type;
          this.cli.reduce_month = val.reduce_month;
          break;
        case '社保-新参保':
          this.show4 = true;
          this.cli.apply_salary = val.apply_salary;
          this.cli.type = val.type;
          this.cli.add_month = val.add_month;
          break;
        case '社保-普通增员':
          this.show4 = true;
          this.cli.apply_salary = val.apply_salary;
          this.cli.type = val.type;
          this.cli.add_month = val.add_month;
          break;
        case '社保-信息变更':
          this.show4 = true;
          this.cli.apply_salary = val.apply_salary;
          this.cli.type = val.type;
          this.cli.add_month = val.add_month;
          break;
        case '公积金-增员':
          this.show4 = true;
          this.cli.apply_salary = val.apply_salary;
          this.cli.type = val.type;
          this.cli.add_month = val.add_month;
          break;
        case '公积金-减员':
          this.show = true;
          if (val.reduce_reason !== undefined) {
            this.cli.reduce_reason = this.reduce_reason[val.reduce_reason - 1];
          }
          break;
        case '社保-员工修改':
          this.show5 = true;
          this.bankOrno = true;
          break;
        case '社保-定点医院变更':
          this.show5 = true;
          break;
        case '社保-个人信息变更':
          this.show5 = true;
          break;
      }

      this.cli.disable = false;
      this.cli.type = val.type;

      if (val.reduce_month !== undefined) {
        this.cli.reduce_month = val.reduce_month;
      }
      if (val.sa !== undefined && val.sa !== '待审核') {
        this.cli.disable = true;
      } else {
        this.cli.disable = false;
      }
      const ix = val.id_card;
      if (ix !== undefined) {
        this.cli.id_card = ix.toString().substr(-4);
      }
      WxSocList({ emp_id: val.emp_id }).then(res => {
        if (res.rows.length > 0) {
          const len = res.rows.length;
          for (let i = 0; i < len; i++) {
            console.log(res.rows[i].pact_begin_date);
            // this.qc.pact_begin_date = res.rows[i].pact_begin_date != '' ? res.rows[i].pact_begin_date : '';
            // this.pact_type = res.rows[i].pact_type > 0 ? res.rows[i].pact_type.toString() : '';
            // this.qc.pact_sign_salary = res.rows[i].pact_sign_salary > 0 ? res.rows[i].pact_sign_salary.toString() : '';
            // this.qc.pact_end_date = res.rows[i].pact_end_date != '' ? res.rows[i].pact_end_date : '';
            // this.qc.pact_sign_date = res.rows[i].pact_sign_date != '' ? res.rows[i].pact_sign_date : '';
            this.bank_name = res.rows[i].bank_name != '' ? res.rows[i].bank_name : '';
            this.card_no = res.rows[i].card_no != '' ? res.rows[i].card_no : '';
          }
        }
      });
    },
    sts() {
      this.toast(this.value2);
      this.query();
    },
    onSearch() {
      this.query();
      this.Searvalue = '';
    },
    query() {
      this.wxbill = [];
      this.axios
        .post('/wxbill/list', {
          emp_name: this.Searvalue,
          emp_id: parseInt(sessionStorage.getItem('emp_id')),
          token: sessionStorage.getItem('token'),
          // status: this.value2,
          page: 1,
          rows: 999
        })
        .then(res => {
          if (res.data.rows !== null) {
            const len = res.data.rows.length;

            for (let i = 0; i < len; i++) {
              this.wxbill.push({
                id: res.data.rows[i].id,
                emp_name: res.data.rows[i].emp_name,
                type: res.data.rows[i].type,
                status: res.data.rows[i].status - 1,
                reduce_month: res.data.rows[i].reduce_month,
                reduce_reason: res.data.rows[i].reduce_reason,
                id_card: res.data.rows[i].id_card,
                sa: this.status[res.data.rows[i].status - 1],
                emp_id: res.data.rows[i].emp_id,
                client_id: res.data.rows[i].client_id,
                add_month: res.data.rows[i].add_month,
                apply_salary: res.data.rows[i].apply_salary,
                feedback: res.data.rows[i].feedback,
                create_time: res.data.rows[i].create_time
              });
            }
          } else {
            this.ifempty = true;
          }
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },

    onClickRight() {}
  }
};
</script>

<style scoped="scoped">
.van-tab__pane-wrapper {
  height: 812px;
}
.pad {
  padding-left: 50px;
  border: 1ox solid #9dc6ff;
  color: red;
}
.box11 {
  width: 98%;
  height: 65px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 10px;
}

.shadow {
  position: relative;
  /* max-width: 570px; */
  box-shadow: 0px 1px 4px #a5bcff, 0px 0px 5px #e3e3e3 inset;
}
.xa {
  position: relative;
  /* max-width: 570px; */
  box-shadow: 0px 1px 4px #426464, 0px 0px 5px #828240 inset;
}
.xa::before,
.xa::after {
  content: '';
  position: absolute;
  z-index: -1;
}

.xa::before,
.xa::after {
  content: '';
  position: absolute;
  z-index: -1;
  bottom: 15px;
  left: 10px;
  width: 50%;
  height: 20%;
}

.xa::before,
.xa::after {
  content: '';
  position: absolute;
  z-index: -1;
  bottom: 15px;
  left: 10px;
  width: 50%;
  height: 20%;
  box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  transform: rotate(-3deg);
}

.xa::after {
  right: 10px;
  left: auto;
  transform: rotate(3deg);
}

.xa::before,
.xa::after {
  content: '';
  position: absolute;
  z-index: -1;
}

.shadow::before,
.shadow::after {
  content: '';
  position: absolute;
  z-index: -1;
  bottom: 15px;
  left: 10px;
  width: 50%;
  height: 20%;
}

.shadow::before,
.shadow::after {
  content: '';
  position: absolute;
  z-index: -1;
  bottom: 15px;
  left: 10px;
  width: 50%;
  height: 20%;
  box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  transform: rotate(-3deg);
}

.shadow::after {
  right: 10px;
  left: auto;
  transform: rotate(3deg);
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.xaaa {
  height: 330px;
}
.xxxa {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/wxbill/list-emp.vue